import script from "./LicenseAgreementView.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseAgreementView.vue?vue&type=script&setup=true&lang=js"

import "./LicenseAgreementView.vue?vue&type=style&index=0&id=4742a805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4742a805"]])

export default __exports__